// Custom fabric events fired to mark the beginning and end of grouped modifications
// onChange handler will not be called while in a group.
// Groups may be nested and the onChange handler will not be called
// until the last group is ended.
export const FABRIC_GROUP_START = 'groupedEvents:start';
export const FABRIC_GROUP_END = 'groupedEvents:end';

/**
 * Different Fabric dimensions depending on orientation
 */
export const CANVAS_ORIENTATION = {
  mobile: {
    portrait: [263, 357],
    landscape: [340, 251],
    square: [334, 334],
  },
  desktop: {
    portrait: [500, 680],
    landscape: [680, 500],
    square: [680, 680],
  },
};

// Custom UYO events
export const UYO_SELECT_FIRST = 'canvas:uyo:select:first';

// Custom textbox events
export const TEXTBOX_SELECT_FIRST = 'canvas:textbox:select:first';

export const DEFAULT_CANVAS_WIDTH = 1000;
export const DEFAULT_CANVAS_HEIGHT = 1360;
